/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import ExamenRespuestas from './ExamenRespuestas';
import {bindActionCreators} from 'redux';
import * as tagActions from '../../actions/tagActions';
import * as formularioActions from '../../actions/formularioActions';
import * as resultadoexamenActions from '../../actions/resultadoexamenActions';
import * as comentariosActions from '../../actions/comentariosActions';

import toastr from 'toastr';
import ManageList from '../common/ManageList';

import { Segment, Header} from 'semantic-ui-react';
import ModalSiNo from '../common/ModalSiNo';
import $ from 'jquery';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import * as cursoActions from '../../actions/cursoActions';
import * as Resultado from '../common/Resultado';

import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import * as infoActions from '../../actions/infoActions';

import {getMargenes} from '../../util/';
import moment from 'moment';

class ManageExamenRespuestas extends React.Component {
    constructor(props, context) {
		
		super(props, context);
        
      
        this.state={
            errors:{},
            strings:{},
            curso:{
                 modulos:[]
             },
            showActivos:true,
            showModal:false,
            filtrosCombo:{},
            permisos:{},
            errores:[],
            appLocale:{
                "singleSelectionTagText":"Seleccion simple",    
                "multipleSelectionTagText":"Selección multiple",  
                "pickNumberOfSelection":"Selecciona <numberOfSelection>",
                "resultPagePoint": "Obtuviste <correctPoints> de un total de <totalPoints>.",
                "landingHeaderText": "La siguiente prueba consta de <questionLength> Preguntas",
                "question": "Pregunta",
                "startQuizBtn": "Comenzar prueba",
                "resultFilterAll": "All",
                "resultFilterCorrect": "Correct",
                "resultFilterIncorrect": "Incorrect",
                "nextQuestionBtn": "Siguiente",
                "resultPageHeaderText": "Tu has completado la prueba. Tuviste <correctIndexLength> correctas de <questionLength> preguntas."
                } ,
            quiz: null,
            visible:true, 
            fechaActual: new moment()
            
		};
	}

	componentDidMount(){
        
     
        this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);
        this.props.showSidebarIzquierdaActions.onShowSidebarIzquierda(false);
       this.cargarExamen(this.props.idForm);
        
   
	}
    
    
    
    cargarExamen=(id)=>{

        
           this.props.resultadoexamenActions.getResultadoExamenUsuario(16, this.props.user).then( examen=>{
                  
                let resultado = JSON.parse(examen.cadena);
                //let resultado = examen;
                //console.log(resultado);
               
                 let errores = this.state.errores;
                    for(let i=0; i<resultado.questions.length; i++){
                       
                        
                        resultado.questions[i].userInput = resultado.userInput[i];

                    }
                   
                
               
                this.setState({"quiz":resultado, "errores": errores});
                 })
                .catch(error=>{
                  toastr.error(error);
            });
        
       
    }

  
  
    
    render() {
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		return (
            <Segment   style={margenes}>
                 
                <ExamenRespuestas
                   
                    strings={this.props.strings}
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    id={this.state.id}
                    quiz={this.state.quiz}
                    setQuizResult={this.setQuizResult}
                    renderCustomResultPage={this.renderCustomResultPage}
                    errores={this.state.errores}
                />
            
             

            </Segment> 
            
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps){
    return {
          

        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda,
        ajaxCallInProgress:state.ajaxCallInProgress,
        color:state.color,
        form:state.form,
        color:state.color,
        strings:state.strings,
        idioma:state.idioma,
        user:state.user,
        strings:state.strings
    }

}


function mapDispatchToProps(dispatch){

	return { 
        paginaActions: bindActionCreators(paginaActions, dispatch),
        infoActions: bindActionCreators(infoActions, dispatch),
        cursoActions: bindActionCreators(cursoActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        formularioActions: bindActionCreators(formularioActions, dispatch),
        resultadoexamenActions: bindActionCreators(resultadoexamenActions, dispatch),
        comentariosActions: bindActionCreators(comentariosActions, dispatch)
 	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageExamenRespuestas);